import { render } from "./ListSdvQueryModal.vue?vue&type=template&id=497cfcd6&scoped=true"
import script from "./ListSdvQueryModal.js?vue&type=script&lang=js"
export * from "./ListSdvQueryModal.js?vue&type=script&lang=js"

import "./ListSdvQueryModal.vue?vue&type=style&index=0&id=497cfcd6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497cfcd6"]])

export default __exports__